import { render } from "./IconLock.vue?vue&type=template&id=9dcbad4c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9dcbad4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9dcbad4c', __exports__)) {
    api.reload('9dcbad4c', __exports__)
  }
  
  module.hot.accept("./IconLock.vue?vue&type=template&id=9dcbad4c", () => {
    api.rerender('9dcbad4c', render)
  })

}


export default __exports__